var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputCell"},[_c('v-textarea',{attrs:{"rows":_vm.inputValue ? 1 : 1,"auto-grow":"","dense":"","outlined":"","hide-details":""},on:{"blur":_vm.onBlur},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }